import { useAppSelector } from 'hooks';
import React from 'react';
import { getNotificationSettingMessage } from './helpers';

export const NotificationSetting = () => {
  const analyzedAccountSetting = useAppSelector((state) => state.requests.analyzedAccountSetting);

  if (!analyzedAccountSetting.length) {
    return <h4>No notification methods have been set by the user.</h4>;
  }

  const message = analyzedAccountSetting.map((setting) => getNotificationSettingMessage(setting)).join('\n');

  return (
    <div>
      <h4>Notifications:</h4>
      <pre>{message}</pre>
    </div>
  );
};
